export const FtpSettingsApiPath = {
  LIST_FTP_CONNECTIONS: '/api/ftp-connections', // GET List Ftp Connections
  UPDATE_FTP_SETTINGS: '/api/sites/{site_id}/ftp-settings', // PUT Update Ftp Settings
  RESET_FTP_PASSWORD: '/api/sites/{site_id}/ftp-password-reset' // POST Reset Ftp Password
}

export type FtpSettingsApiPath = (typeof FtpSettingsApiPath)[keyof typeof FtpSettingsApiPath]

export interface ListFtpConnectionsVars {}

export interface UpdateFtpSettingsVars {
  site_id: number
  ftp_enabled: boolean
  ftp_username?: string | null
  ftp_password?: string | null
}

export interface ResetFtpPasswordVars {
  site_id: number
}

export interface UpdateFtpSettingsResponse {
  ftp_enabled: boolean
  ftp_username: string | null
  ftp_password: string | null
}

export interface ResetFtpPasswordResponse {
  ftp_password: string
}

export interface FtpConnection {
  protocol: string
  port: number
}

export interface ListFtpConnectionsResponse {
  connections: FtpConnection[]
}
